module.exports = __webpack_public_path__ + "static/media/20.jpg.f26ebbd9.webp";